/* ==========================================================================
   Mobile Sticky Search Fix - Casa Krysthal
   Version: 190 - Complete rewrite for immediate functionality
   ========================================================================== */

console.log('[Krysthal Sticky Fix] Loading v190');

// Global variable to store sticky autocomplete container
let stickyAutocompleteContainer = null;

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 768) return;
  
  console.log('[Krysthal Sticky Fix] Initializing mobile sticky search');
  
  // Create and setup sticky header immediately
  createStickyHeader();
});

function createStickyHeader() {
  // Create sticky header structure
  const stickyHeader = document.createElement('div');
  stickyHeader.className = 'mobile-sticky-header';
  stickyHeader.innerHTML = `
    <div class="mobile-sticky-inner">
      <button class="mobile-sticky-menu" onclick="toggleMobileMenu()" aria-label="Menu">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>
      <form action="/search" method="get" role="search" class="mobile-sticky-search">
        <input type="search" 
               id="sticky-search-input"
               name="q" 
               placeholder="O que deseja procurar?" 
               aria-label="Buscar produtos"
               autocomplete="off">
        <button type="submit" aria-label="Buscar">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </form>
      <button class="mobile-sticky-cart" onclick="openCartDrawer()" aria-label="Carrinho">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"/>
          <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"/>
          <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6"/>
        </svg>
        <span class="cart-count mobile-sticky-cart-count" style="display: none;">0</span>
      </button>
    </div>
  `;
  
  // Insert at body start
  document.body.insertBefore(stickyHeader, document.body.firstChild);
  
  // Create autocomplete container for sticky search
  stickyAutocompleteContainer = document.createElement('div');
  stickyAutocompleteContainer.id = 'sticky-autocomplete';
  stickyAutocompleteContainer.className = 'search-autocomplete sticky-search-autocomplete';
  stickyAutocompleteContainer.style.cssText = `
    position: fixed !important;
    background: white !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 0 !important;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    z-index: 2147483647 !important;
    display: none;
  `;
  document.body.appendChild(stickyAutocompleteContainer);
  
  // Get the input
  const stickyInput = document.getElementById('sticky-search-input');
  if (!stickyInput) {
    console.error('[Krysthal Sticky Fix] Sticky input not found!');
    return;
  }
  
  // Setup search functionality
  setupStickySearch(stickyInput, stickyAutocompleteContainer);
  
  // Handle scroll to show/hide sticky header
  let lastScrollTop = 0;
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 150) {
      stickyHeader.classList.add('active');
      document.body.classList.add('sticky-search-visible');
    } else {
      stickyHeader.classList.remove('active');
      document.body.classList.remove('sticky-search-visible');
      // Hide autocomplete when header is hidden
      stickyAutocompleteContainer.style.display = 'none';
    }
    
    lastScrollTop = scrollTop;
  });
  
  // Update cart count if function exists
  if (window.updateGlobalCartCount) {
    window.updateGlobalCartCount();
  }
}

function setupStickySearch(input, container) {
  console.log('[Krysthal Sticky Fix] Setting up search for input:', input);
  
  let searchTimeout;
  let isMouseDown = false;
  
  // Track mouse state for autocomplete
  container.addEventListener('mousedown', () => isMouseDown = true);
  container.addEventListener('mouseup', () => isMouseDown = false);
  
  // Handle search input
  function handleSearch() {
    const query = input.value.trim();
    console.log('[Krysthal Sticky Fix] Search query:', query);
    
    clearTimeout(searchTimeout);
    
    if (query.length < 2) {
      container.style.display = 'none';
      return;
    }
    
    searchTimeout = setTimeout(() => {
      performSearch(query, input, container);
    }, 300);
  }
  
  // Handle focus to show suggestions
  function handleFocus() {
    const query = input.value.trim();
    console.log('[Krysthal Sticky Fix] Focus event, query:', query);
    
    setTimeout(() => {
      if (query.length >= 2) {
        handleSearch();
      } else {
        showSuggestions(input, container);
      }
    }, 100); // Small delay to ensure focus is complete
  }
  
  // Handle blur to hide
  function handleBlur() {
    setTimeout(() => {
      if (!isMouseDown) {
        container.style.display = 'none';
      }
    }, 200);
  }
  
  // Add event listeners
  input.addEventListener('input', handleSearch);
  input.addEventListener('focus', handleFocus);
  input.addEventListener('blur', handleBlur);
  
  // Hide on scroll
  window.addEventListener('scroll', () => {
    container.style.display = 'none';
  });
  
  // Hide on outside click
  document.addEventListener('click', (e) => {
    if (!input.contains(e.target) && !container.contains(e.target)) {
      container.style.display = 'none';
    }
  });
}

function performSearch(query, input, container) {
  console.log('[Krysthal Sticky Fix] Performing search for:', query);
  
  // IMPORTANTE: Esconder TODOS os outros containers de autocomplete
  document.querySelectorAll('.search-autocomplete').forEach(el => {
    if (el !== container) {
      el.style.display = 'none';
    }
  });
  
  // Show loading
  container.innerHTML = '<div style="padding: 15px; text-align: center;">Buscando...</div>';
  positionContainer(input, container);
  container.style.display = 'block';
  
  // Fetch results
  fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
    .then(response => response.json())
    .then(data => {
      const products = data.resources?.results?.products || [];
      console.log('[Krysthal Sticky Fix] Found products:', products.length);
      
      if (products.length > 0) {
        container.innerHTML = '';
        
        products.forEach(product => {
          const item = document.createElement('a');
          item.href = product.url;
          item.className = 'search-autocomplete-item';
          item.style.cssText = `
            display: flex !important;
            align-items: center !important;
            padding: 10px 15px !important;
            text-decoration: none !important;
            color: #333 !important;
            border-bottom: 1px solid #f0f0f0 !important;
            background: white !important;
          `;
          
          const imageHtml = product.image 
            ? `<img src="${product.image}" alt="${product.title}" style="width: 40px; height: 40px; object-fit: cover; margin-right: 10px; border-radius: 5px;">` 
            : '';
          
          item.innerHTML = `
            ${imageHtml}
            <div style="flex: 1;">
              <div style="font-weight: 500; color: #333; font-size: 14px;">${product.title}</div>
              <div style="color: #F15A29; font-weight: bold; font-size: 13px;">R$ ${product.price}</div>
            </div>
          `;
          
          item.onmouseover = () => item.style.background = '#f5f5f5';
          item.onmouseout = () => item.style.background = 'white';
          
          container.appendChild(item);
        });
        
        // Add "view all" link
        const viewAll = document.createElement('a');
        viewAll.href = `/search?q=${encodeURIComponent(query)}`;
        viewAll.style.cssText = `
          display: block !important;
          padding: 15px !important;
          text-align: center !important;
          color: #F15A29 !important;
          font-weight: 600 !important;
          text-decoration: none !important;
          background: #f9f9f9 !important;
        `;
        viewAll.textContent = `Ver todos os resultados para "${query}"`;
        container.appendChild(viewAll);
        
      } else {
        container.innerHTML = '<div style="padding: 15px; text-align: center;">Nenhum produto encontrado</div>';
      }
      
      positionContainer(input, container);
    })
    .catch(error => {
      console.error('[Krysthal Sticky Fix] Search error:', error);
      container.innerHTML = '<div style="padding: 15px; text-align: center;">Erro na busca</div>';
    });
}

function showSuggestions(input, container) {
  console.log('[Krysthal Sticky Fix] Showing suggestions');
  
  // IMPORTANTE: Esconder TODOS os outros containers de autocomplete
  document.querySelectorAll('.search-autocomplete').forEach(el => {
    if (el !== container) {
      el.style.display = 'none';
    }
  });
  
  const suggestions = [
    { text: 'Barbantes', icon: '🧵' },
    { text: 'Agulhas', icon: '📍' },
    { text: 'Fio de malha', icon: '🧶' },
    { text: 'Lã', icon: '🧶' }
  ];
  
  container.innerHTML = '<div style="padding: 10px 15px; color: #666; font-size: 13px; border-bottom: 1px solid #f0f0f0;">Sugestões de busca:</div>';
  
  suggestions.forEach(suggestion => {
    const item = document.createElement('a');
    item.href = '#';
    item.style.cssText = `
      display: flex !important;
      align-items: center !important;
      padding: 12px 15px !important;
      text-decoration: none !important;
      color: #333 !important;
      border-bottom: 1px solid #f0f0f0 !important;
      background: white !important;
    `;
    
    item.innerHTML = `
      <span style="font-size: 18px; margin-right: 10px;">${suggestion.icon}</span>
      <span style="font-size: 14px;">${suggestion.text}</span>
    `;
    
    item.onmouseover = () => item.style.background = '#f5f5f5';
    item.onmouseout = () => item.style.background = 'white';
    
    item.onclick = (e) => {
      e.preventDefault();
      input.value = suggestion.text;
      input.focus();
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    };
    
    container.appendChild(item);
  });
  
  positionContainer(input, container);
  container.style.display = 'block';
}

function positionContainer(input, container) {
  const rect = input.getBoundingClientRect();
  container.style.top = (rect.bottom + 5) + 'px';
  container.style.left = rect.left + 'px';
  container.style.width = rect.width + 'px';
}